export default __webpack_public_path__ + "static/media/job-details-empty-state.27902c6f.png";